import { render, staticRenderFns } from "./ForArtists.vue?vue&type=template&id=c4e44c82&scoped=true&"
import script from "./ForArtists.vue?vue&type=script&lang=js&"
export * from "./ForArtists.vue?vue&type=script&lang=js&"
import style0 from "./ForArtists.vue?vue&type=style&index=0&id=c4e44c82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e44c82",
  null
  
)

export default component.exports